import { ThemePalette } from "../../../theme";
import styled, { css } from "styled-components";
import {
  BorderType,
  InputBorderProps,
  InputCssProps,
  InputLoaderProps,
} from "./Input.types";

export const InputContainer = styled.div`
  padding: 0.3rem 0;
  position: relative;
  margin-left: 0.5rem;
`;

const showRequiredIndicatorCss = () => css`
  &:after {
    content: "*";
    margin-left: 0.2rem;
    color: red;
  }
`;
const errorTitle = () => css<InputBorderProps>`
  color: ${(props: InputBorderProps) => props.theme!.colorWarning} !important;
`;

export const InputTitle = styled.span<InputBorderProps>`
  position: absolute;
  top: 0.1rem;
  left: -0.8rem;
  ${(props: InputBorderProps) =>
    props.isRequired && showRequiredIndicatorCss()};
  ${(props: InputBorderProps) => props.hasError && errorTitle()}
`;

export const PropelInput = styled.input<InputCssProps>`
  border: none;
  width: 98%;
  outline: none;
  padding: 0.5rem 0.5rem 0 0.5rem;
  background: ${(props: InputCssProps) => props.theme!.colorWhite};
  background: transparent;
  z-index: 1;
  position: relative;
  /* top: 4px; */
  left: 3rem;
  box-sizing: border-box;
  /* padding-top: 0.5rem; */
  :hover {
    cursor: pointer;
  }
  &:focus {
    box-shadow: 0 0 0.3rem ${ThemePalette.colorPrimary};
  }
  /* :focus + span {
    border: 3px solid ${(props: InputCssProps) => props.theme!.colorPrimary};
    border-radius: 0.3rem;
  }
  :hover + span {
    cursor: pointer;
    border: 3px solid ${(props: InputCssProps) => props.theme!.colorPrimary};
    border-radius: 0.3rem;
  } */
`;
const showErrorCss = () => css<InputBorderProps>`
  border: 3px solid ${(props: InputBorderProps) => props.theme!.colorWarning};
`;

const completeBorderCss = () => css<InputBorderProps>`
  border: 0.1rem solid
    ${(props: InputBorderProps) => props.theme!.colorPrimaryLight};
  border-radius: 0.3rem;
  background: ${(props: InputBorderProps) => props.theme!.colorWhite};
`;
const bottomBorderCss = () => css<InputBorderProps>`
  background: ${(props: InputBorderProps) => props.theme!.colorGrayLight}30;
  border-bottom: 0.1rem solid
    ${(props: InputBorderProps) => props.theme!.colorPrimary};
`;
export const InputBorderSpan = styled.span<InputBorderProps>`
  ${(props) => props.borderType === BorderType.complete && completeBorderCss()};
  ${(props) => props.borderType === BorderType.bottom && bottomBorderCss()};
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 2.5rem;
  left: 0;
  z-index: 0;
  ${(props: InputBorderProps) => (props.hasError ? showErrorCss() : undefined)};
`;

export const ErrorMessageContainer = styled.span<InputBorderProps>`
  color: ${(props: InputBorderProps) => props.theme!.colorWarning};
  font-size: 0.8rem;
  position: absolute;
  bottom: 0;
  left: 0.5rem;
`;
export const FloatingComponentSpan = styled.span`
  position: absolute;
  right: 0.5rem;
  top: 2.6rem;
  z-index: 999;
  cursor: pointer;
`;
export const LeadingComponentSpan = styled.span`
  position: absolute;
  left: 0.5rem;
  top: 2.6rem;
  z-index: 999;
  cursor: pointer;
`;

export const Loader = styled.span<InputLoaderProps>`
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: ${(props: InputLoaderProps) => (props.isCleared ? "3rem" : "1rem")};
  top: 2.2rem;
`;

InputTitle.defaultProps = {
  isRequired: false,
  hasError: false,
};
PropelInput.defaultProps = {
  theme: ThemePalette,
};
ErrorMessageContainer.defaultProps = {
  theme: ThemePalette,
};

InputBorderSpan.defaultProps = {
  hasError: false,
  isRequired: false,
  theme: ThemePalette,
};
